import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * fetch login member's joined communities
 * @returns {Promise}
 */
export const fetchJoinedCommunities = async () => {
  const response = await apiRequest('/api/community', CONST.api_method.get);
  return response;
};

export const fetchJoinedCommunity = async cid => {
  const response = await apiRequest(`/api/community/cid/${cid}`, CONST.api_method.get);
  return response;
};

/**
 * create new community
 * @param data
 * @returns {Promise}
 */
export const createCommunity = async data => {
  const response = await apiRequest('/api/community', CONST.api_method.post, data, true);
  return response.data;
};

export const sortCommunity = async data => {
  const response = await apiRequest('/api/community/sort', CONST.api_method.post, data, true);
  return response.data;
};

/**
 * get community's setting
 * @returns {Promise}
 */
export const getCommunitySetting = async id => {
  let url = '/api/community/' + id + '/setting';
  const response = await apiRequest(`/api/community/${id}/setting`, CONST.api_method.get);
  return response.data;
};

/**
 * update community setting
 * @param id
 * @param data
 * @returns {Promise}
 */
export const updateCommunitySetting = async data => {
  const response = await apiRequest(`/api/community/setting`, CONST.api_method.post, data);
  return response.data;
};

/**
 * get community's covers
 * @returns {Promise}
 */
export const getCommunityDefaultCovers = async () => {
  const response = await apiRequest(`/api/community/cover`, CONST.api_method.get);
  return response.data;
};

/**
 * get community's covers
 * @returns {Promise}
 */
export const getCommunityCovers = async id => {
  const response = await apiRequest(`/api/community/${id}/cover`, CONST.api_method.get);
  return response.data;
};

/**
 * get community's covers
 * @returns {Promise}
 */
export const isMemberCountExceeded = async id => {
  const response = await apiRequest(`/api/community/${id}/check-member-count/`, CONST.api_method.get);
  return response.data;
};

/**
 * update community photo setting
 * @param data
 * @returns {Promise}
 */
export const updateCommunityCover = async data => {
  const response = await apiRequest('/api/community/cover', CONST.api_method.post, data, true);
  return response.data;
};

/**
 * unsubscribe
 * @param data
 * @returns {Promise}
 */
export const unsubscribe = async data => {
  const response = await apiRequest('/api/community/unsubscribe', CONST.api_method.post, data);
  return response.data;
};

/**
 * dissolution
 * @param data
 * @returns {Promise}
 */
export const dissolution = async data => {
  const response = await apiRequest('/api/community/dissolution', CONST.api_method.post, data);
  return response.data;
};

export default {
  fetchJoinedCommunities,
  fetchJoinedCommunity,
  createCommunity,
  sortCommunity,
  getCommunitySetting,
  updateCommunitySetting,
  getCommunityDefaultCovers,
  getCommunityCovers,
  isMemberCountExceeded,
  updateCommunityCover,
  unsubscribe,
  dissolution,
};
